module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticStyle: {
      "white-space": "pre-line"
    },
    attrs: {
      "id": _vm.id
    }
  }, [_vm._v(_vm._s(_vm.label) + " "), _c('HelpTextUrl', {
    attrs: {
      "help_text_url": _vm.help_text_url
    }
  })], 1), _vm._v(" "), (_vm.help_text) ? [_c('HelpText', {
    attrs: {
      "help_text": _vm.help_text
    }
  })] : _vm._e(), _vm._v(" "), (_vm.readonly) ? [(!_vm.isMultiple) ? _c('select', {
    ref: "selectB",
    staticClass: "form-control",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": "",
      "id": _vm.selectid,
      "name": _vm.name,
      "data-conditions": _vm.cons
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select...")]), _vm._v(" "), _vm._l((_vm.species), function(op, idx1) {
    return _c('option', {
      key: ("value_" + (op.value) + "_" + idx1),
      domProps: {
        "value": op.value,
        "selected": op.value == _vm.value
      },
      on: {
        "change": _vm.handleChange
      }
    }, [_vm._v(_vm._s(op.label))])
  })], 2) : _c('select', {
    ref: "selectB",
    staticClass: "form-control",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": "",
      "id": _vm.selectid,
      "multiple": ""
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select...")]), _vm._v(" "), _vm._l((_vm.species), function(op, idx1) {
    return _c('option', {
      key: ("value_" + (op.value) + "_" + idx1),
      domProps: {
        "value": op.value,
        "selected": _vm.multipleSelection(op.value)
      }
    }, [_vm._v(_vm._s(op.label))])
  })], 2), _vm._v(" "), (_vm.isMultiple) ? _vm._l((_vm.value), function(v, idx2) {
    return _c('input', {
      key: ("value_" + v + "_" + idx2),
      attrs: {
        "input": "",
        "type": "hidden",
        "name": _vm.name,
        "required": _vm.isRequired
      },
      domProps: {
        "value": v
      }
    })
  }) : [_c('input', {
    attrs: {
      "type": "hidden",
      "name": _vm.name,
      "required": _vm.isRequired
    },
    domProps: {
      "value": _vm.value
    }
  })]] : [(!_vm.isMultiple) ? _c('select', {
    ref: "selectB",
    staticClass: "form-control",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": _vm.selectid,
      "name": _vm.name,
      "data-conditions": _vm.cons,
      "required": _vm.isRequired
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select...")]), _vm._v(" "), _vm._l((_vm.species), function(op, idx1) {
    return _c('option', {
      key: ("value_" + (op.value) + "_" + idx1),
      domProps: {
        "value": op.value,
        "selected": op.value == _vm.value
      },
      on: {
        "change": _vm.handleChange
      }
    }, [_vm._v(_vm._s(op.label))])
  })], 2) : _c('select', {
    ref: "selectB",
    staticClass: "form-control",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": _vm.selectid,
      "name": _vm.name,
      "multiple": "",
      "required": _vm.isRequired
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select...")]), _vm._v(" "), _vm._l((_vm.species), function(op, idx1) {
    return _c('option', {
      key: ("value_" + (op.value) + "_" + idx1),
      domProps: {
        "value": op.value,
        "selected": _vm.multipleSelection(op.value)
      }
    }, [_vm._v(_vm._s(op.label))])
  })], 2)]], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c2e75e7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/select_species.vue
// module id = 970
// module chunks = 0